import { useMemo } from "react";

import type { HotelTopQuery } from "@/lib/gql/__generated__/graphql";

const HTTPS = "https://";

export const useHotelFullUrls = (hotelUrls: HotelTopQuery["hotelUrls"]) => {
	const fullUrlPlain = useMemo(
		() => (hotelUrls.urlPlain ? `${HTTPS}${hotelUrls.urlPlain}` : ""),
		[hotelUrls.urlPlain],
	);
	const fullUrlMagazine = useMemo(
		() => (hotelUrls.urlMagazine ? `${HTTPS}${hotelUrls.urlMagazine}` : ""),
		[hotelUrls.urlMagazine],
	);
	const fullUrlSnack = useMemo(
		() => (hotelUrls.urlSnack ? `${HTTPS}${hotelUrls.urlSnack}` : ""),
		[hotelUrls.urlSnack],
	);

	return { fullUrlPlain, fullUrlMagazine, fullUrlSnack };
};
